export const defaultTransitionTiming = {
  fastest: 0.1, // micro block
  faster: 0.2, // small blocks
  fast: 0.3, // medium block
  normal: 0.4, // moving animations like sliders
}
